<template>
  <div class="enterpriseAndCommonality">
    <div class="AddSupplierA">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
        class="contactsForm"
      >
        <div class="AddSupplierATitle">企业信息</div>
        <div class="AddSupplierAContent">
          <!-- <esoterica @setIsShowHelpExplain="setIsShowHelpExplain"></esoterica> -->

          <el-row>
            <el-col :span="12">
              <!--公司名称-->
              <el-form-item
                class="noMarginBottom"
                label="公司名称："
                prop="companyName"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.companyName"
                  maxlength="60"
                  placeholder="请输入公司名称"
                ></el-input>
              </el-form-item>
              <!-- <div class="phoneStatement">请按照营业执照上登记的完整名称填写</div> -->
            </el-col>
            <el-col :span="12">
              <!--注册地址-->
              <el-form-item
                class="noMarginBottom"
                label="注册地址："
                prop="registeAddress"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.registeAddress"
                  maxlength="60"
                  placeholder="请输入注册地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--办公地址-->
              <el-form-item
                class="noMarginBottom"
                label="办公地址："
                prop="workAddress"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.workAddress"
                  maxlength="60"
                  placeholder="请输入办公地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--办公电话-->
              <el-form-item
                label="办公电话："
                class="noMarginBottom"
                prop="workPhone"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.workPhone"
                  maxlength="20"
                  placeholder="请输入办公电话"
                  @blur="shopNameBlur"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--法人姓名-->
              <el-form-item
                class="noMarginBottom"
                label="法人姓名："
                prop="legalPerson"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.legalPerson"
                  maxlength="12"
                  placeholder="请输入法人姓名"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="AddSupplierATitle">对公户信息</div>
        <div class="AddSupplierAContent">
          <el-row>
            <el-col :span="12">
              <!--公司名称-->
              <el-form-item
                class="noMarginBottom"
                label="公司名称："
                prop="publicCompanyName"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicCompanyName"
                  maxlength="60"
                  placeholder="请输入公司名称"
                ></el-input>
              </el-form-item>
              <!-- <div class="phoneStatement">请按照营业执照上登记的完整名称填写</div> -->
            </el-col>
            <el-col :span="12">
              <!--开户行-->
              <el-form-item
                class="noMarginBottom"
                label="开户行："
                prop="publicBank"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicBank"
                  maxlength="60"
                  placeholder="请输入开户行名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--开户行地址-->
              <el-form-item
                class="noMarginBottom"
                label="开户行地址："
                prop="publicBankAddress"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicBankAddress"
                  maxlength="60"
                  placeholder="请输入开户行地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--开户行账号-->
              <el-form-item
                class="noMarginBottom"
                label="账号："
                prop="publicBankAccount"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicBankAccount"
                  maxlength="24"
                  placeholder="请输入对公户账号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--税号-->
              <el-form-item
                class="noMarginBottom"
                label="税号："
                prop="publicTaxAccount"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicTaxAccount"
                  maxlength="24"
                  placeholder="请输入对公户税号"
                  @input="publicTaxAccountInput"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--开户行行号-->
              <el-form-item
                class="noMarginBottom"
                label="开户行行号："
                prop="publicBankNumber"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicBankNumber"
                  maxlength="24"
                  placeholder="请输入开户行行号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--对公电话-->
              <el-form-item
                class="noMarginBottom"
                label="对公户电话："
                prop="publicPhone"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicPhone"
                  maxlength="12"
                  placeholder="请输入对公户电话号码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="AddSupplierATitle">联系人信息</div>
        <div class="AddSupplierAContent">
          <el-row>
            <el-col :span="12">
              <!--联系人姓名-->
              <el-form-item
                class="noMarginBottom"
                label="联系人姓名："
                prop="contactName"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.contactName"
                  maxlength="30"
                  placeholder="请输入联系人姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--联系人电话-->
              <el-form-item
                class="noMarginBottom"
                label="联系人电话："
                prop="contactPhone"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.contactPhone"
                  maxlength="12"
                  placeholder="请输入联系人电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--电子邮箱-->
              <el-form-item
                class="noMarginBottom"
                label="电子邮箱："
                prop="contactEmail"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.contactEmail"
                  maxlength="30"
                  placeholder="请输入电子邮箱"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--对公电话-->
              <el-form-item
                class="noMarginBottom"
                label="传真电话："
                prop="contactFax"
              >
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.contactFax"
                  maxlength="12"
                  placeholder="请输入传真电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="AddSupplierATitle">开票信息</div>
        <div class="AddSupplierAContent">
          <el-row>
            <el-col :span="12">
              <el-form-item class="noMarginBottom" label="发票抬头：">
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicCompanyName"
                  maxlength="60"
                  placeholder="请输入发票抬头"
                  readonly
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="noMarginBottom" label="纳税人识别号：">
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicTaxAccount"
                  maxlength="60"
                  placeholder="请输入纳税人识别号"
                  readonly
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item class="noMarginBottom" label="单位地址：">
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.registeAddress"
                  maxlength="60"
                  placeholder="请输入单位地址"
                  readonly
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="noMarginBottom" label="电话号码：">
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.workPhone"
                  maxlength="12"
                  placeholder="请输入电话号码"
                  readonly
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item class="noMarginBottom" label="开户银行：">
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicBank"
                  maxlength="60"
                  placeholder="请输入开户银行"
                  readonly
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="noMarginBottom" label="银行账号：">
                <el-input
                  class="contactsInput"
                  v-model="ruleForm.publicBankAccount"
                  maxlength="24"
                  placeholder="请输入银行账号"
                  readonly
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="AddSupplierATitle">图片</div>
        <div class="AddSupplierAContent">
          <el-row>
            <el-col :span="12">
              <!--营业执照正本（通过年审）-->
              <div class="businessBox">
                <div class="certificateTitle">
                  <span>营业执照正本(通过年审)</span>
                  <el-popover placement="top-start" width="400" trigger="hover">
                    <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                  </el-popover>
                  <span>：</span>
                </div>
                <div class="addImgUploadBox">
                  <el-upload
                    class="addImgUpload"
                    :action="uploadPicUrl"
                    :show-file-list="isShowFileList"
                    :data="uploadData"
                    :limit="addImgUploadLimit2"
                    :on-success="triangleUploadSuccess"
                    list-type="text"
                    accept="image/*"
                    :on-exceed="exceedFilesNum2"
                    :before-upload="beforeUpload"
                    :file-list="triangleFileImgList"
                    :headers="headers"
                  >
                    <div class="addImgBox">
                      <div class="addImgIcon">
                        <img
                          src="@/assets/images/supplierImg/addImgIcon.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="imgIconTxt">
                      图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                      <span v-show="triangleFileList.length != 0"
                        >（{{ triangleFileList.length }}/2）</span
                      >。
                    </div>
                  </el-upload>
                  <div
                    class="UploadImgList"
                    v-if="triangleFileList.length != 0"
                  >
                    <div
                      class="UploadImgItem"
                      v-for="(
                        cosmeticSanitationFileItem, cosmeticSanitationFileIndex
                      ) in triangleFileList"
                      :key="
                        'cosmeticSanitationFileItem' +
                        cosmeticSanitationFileIndex
                      "
                    >
                      <div class="UploadImgLeft">
                        <div class="UploadItemImg">
                          <img :src="cosmeticSanitationFileItem.url" alt="" />
                        </div>
                        <div class="UploadItemInfo">
                          <div class="UploadItemName">
                            图片{{ cosmeticSanitationFileIndex + 1 }}
                          </div>
                        </div>
                      </div>
                      <div class="UploadImgBtnList">
                        <div
                          @click="
                            handletriangleRemove(cosmeticSanitationFileItem)
                          "
                        >
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click="
                            handlePictureCardPreview(cosmeticSanitationFileItem)
                          "
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12" style="padding-left: 40px">
              <!--资质证书（通过年审）-->
              <div class="businessBox">
                <div class="certificateTitle">
                  <span>资质证明(通过年审)</span>
                  <el-popover placement="top-start" width="400" trigger="hover">
                    <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                  </el-popover>
                  <span>：</span>
                </div>
                <div class="addImgUploadBox">
                  <el-upload
                    class="addImgUpload"
                    :action="uploadPicUrl"
                    :show-file-list="isShowFileList"
                    :data="uploadData"
                    :limit="addImgUploadLimit2"
                    :on-success="cosmeticSanitationUploadSuccess"
                    list-type="text"
                    accept="image/*"
                    :on-exceed="exceedFilesNum2"
                    :before-upload="beforeUpload"
                    :file-list="cosmeticSanitationFileImgList"
                    :headers="headers"
                  >
                    <div class="addImgBox">
                      <div class="addImgIcon">
                        <img
                          src="@/assets/images/supplierImg/addImgIcon.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="imgIconTxt">
                      图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                      <span v-show="cosmeticSanitationFileList.length != 0"
                        >（{{ cosmeticSanitationFileList.length }}/2）</span
                      >。
                    </div>
                  </el-upload>
                  <div
                    class="UploadImgList"
                    v-if="cosmeticSanitationFileList.length != 0"
                  >
                    <div
                      class="UploadImgItem"
                      v-for="(
                        cosmeticSanitationFileItem, cosmeticSanitationFileIndex
                      ) in cosmeticSanitationFileList"
                      :key="
                        'cosmeticSanitationFileItem' +
                        cosmeticSanitationFileIndex
                      "
                    >
                      <div class="UploadImgLeft">
                        <div class="UploadItemImg">
                          <img :src="cosmeticSanitationFileItem.url" alt="" />
                        </div>
                        <div class="UploadItemInfo">
                          <div class="UploadItemName">
                            图片{{ cosmeticSanitationFileIndex + 1 }}
                          </div>
                        </div>
                      </div>
                      <div class="UploadImgBtnList">
                        <div
                          @click="
                            handleCosmeticSanitationRemove(
                              cosmeticSanitationFileItem
                            )
                          "
                        >
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click="
                            handlePictureCardPreview(cosmeticSanitationFileItem)
                          "
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <!--安全生产许可证（有效期内）-->
              <div class="businessBox">
                <div class="certificateTitle">
                  <span>安全生产许可证(有效期内)</span>
                  <el-popover placement="top-start" width="400" trigger="hover">
                    <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                  </el-popover>
                  <span>：</span>
                </div>
                <div class="addImgUploadBox">
                  <el-upload
                    class="addImgUpload"
                    :action="uploadPicUrl"
                    :show-file-list="isShowFileList"
                    :data="uploadData"
                    :limit="addImgUploadLimit2"
                    :on-success="safetyProductionLicenseAttachmentUploadSuccess"
                    list-type="text"
                    accept="image/*"
                    :on-exceed="exceedFilesNum2"
                    :before-upload="beforeUpload"
                    :file-list="safetyProductionLicenseAttachmentImgList"
                    :headers="headers"
                  >
                    <div class="addImgBox">
                      <div class="addImgIcon">
                        <img
                          src="@/assets/images/supplierImg/addImgIcon.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="imgIconTxt">
                      图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                      <span
                        v-show="
                          safetyProductionLicenseAttachmentList.length != 0
                        "
                        >（{{
                          safetyProductionLicenseAttachmentList.length
                        }}/2）</span
                      >。
                    </div>
                  </el-upload>
                  <div
                    class="UploadImgList"
                    v-if="safetyProductionLicenseAttachmentList.length != 0"
                  >
                    <div
                      class="UploadImgItem"
                      v-for="(
                        FileItem, FileIndex
                      ) in safetyProductionLicenseAttachmentList"
                      :key="'FileItem' + FileIndex"
                    >
                      <div class="UploadImgLeft">
                        <div class="UploadItemImg">
                          <img :src="FileItem.url" alt="" />
                        </div>
                        <div class="UploadItemInfo">
                          <div class="UploadItemName">
                            图片{{ FileIndex + 1 }}
                          </div>
                        </div>
                      </div>
                      <div class="UploadImgBtnList">
                        <div
                          @click="
                            handlesafetyProductionLicenseAttachmentRemove(
                              FileItem
                            )
                          "
                        >
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click="handlePictureCardPreview(FileItem)"
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12" style="padding-left: 40px">
              <!--劳务资质证书（通过年审）-->
              <div class="businessBox">
                <div class="certificateTitle">
                  <span>劳务资质证书(通过年审)</span>
                  <el-popover placement="top-start" width="400" trigger="hover">
                    <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                  </el-popover>
                  <span>：</span>
                </div>
                <div class="addImgUploadBox">
                  <el-upload
                    class="addImgUpload"
                    :action="uploadPicUrl"
                    :show-file-list="isShowFileList"
                    :data="uploadData"
                    :limit="addImgUploadLimit2"
                    :on-success="laborQualificationAttachmentUploadSuccess"
                    list-type="text"
                    accept="image/*"
                    :on-exceed="exceedFilesNum2"
                    :before-upload="beforeUpload"
                    :file-list="laborQualificationAttachmentImgList"
                    :headers="headers"
                  >
                    <div class="addImgBox">
                      <div class="addImgIcon">
                        <img
                          src="@/assets/images/supplierImg/addImgIcon.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="imgIconTxt">
                      图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                      <span
                        v-show="laborQualificationAttachmentList.length != 0"
                        >（{{
                          laborQualificationAttachmentList.length
                        }}/2）</span
                      >。
                    </div>
                  </el-upload>
                  <div
                    class="UploadImgList"
                    v-if="laborQualificationAttachmentList.length != 0"
                  >
                    <div
                      class="UploadImgItem"
                      v-for="(
                        FileItem, FileIndex
                      ) in laborQualificationAttachmentList"
                      :key="'FileItem' + FileIndex"
                    >
                      <div class="UploadImgLeft">
                        <div class="UploadItemImg">
                          <img :src="FileItem.url" alt="" />
                        </div>
                        <div class="UploadItemInfo">
                          <div class="UploadItemName">
                            图片{{ FileIndex + 1 }}
                          </div>
                        </div>
                      </div>
                      <div class="UploadImgBtnList">
                        <div
                          @click="
                            handlelaborQualificationAttachmentRemove(FileItem)
                          "
                        >
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click="handlePictureCardPreview(FileItem)"
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--法人身份证-->
              <div class="businessBox">
                <div class="certificateTitle">
                  <span>法人身份证</span>
                  <el-popover placement="top-start" width="400" trigger="hover">
                    <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                  </el-popover>
                  <span>：</span>
                </div>
                <div class="addImgUploadBox">
                  <el-upload
                    class="addImgUpload"
                    :action="uploadPicUrl"
                    :show-file-list="isShowFileList"
                    :data="uploadData"
                    :limit="addImgUploadLimit2"
                    :on-success="corporateIdCardAttachmentUploadSuccess"
                    list-type="text"
                    accept="image/*"
                    :on-exceed="exceedFilesNum2"
                    :before-upload="beforeUpload"
                    :file-list="corporateIdCardAttachmentImgList"
                    :headers="headers"
                  >
                    <div class="addImgBox">
                      <div class="addImgIcon">
                        <img
                          src="@/assets/images/supplierImg/addImgIcon.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="imgIconTxt">
                      图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                      <span v-show="corporateIdCardAttachmentList.length != 0"
                        >（{{ corporateIdCardAttachmentList.length }}/2）</span
                      >。
                    </div>
                  </el-upload>
                  <div
                    class="UploadImgList"
                    v-if="corporateIdCardAttachmentList.length != 0"
                  >
                    <div
                      class="UploadImgItem"
                      v-for="(
                        FileItem, FileIndex
                      ) in corporateIdCardAttachmentList"
                      :key="'FileItem' + FileIndex"
                    >
                      <div class="UploadImgLeft">
                        <div class="UploadItemImg">
                          <img :src="FileItem.url" alt="" />
                        </div>
                        <div class="UploadItemInfo">
                          <div class="UploadItemName">
                            图片{{ FileIndex + 1 }}
                          </div>
                        </div>
                      </div>
                      <div class="UploadImgBtnList">
                        <div
                          @click="
                            handlecorporateIdCardAttachmentRemove(FileItem)
                          "
                        >
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click="handlePictureCardPreview(FileItem)"
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12" style="padding-left: 40px">
              <!--委托人身份证-->
              <div class="businessBox">
                <div class="certificateTitle">
                  <span>委托人身份证</span>
                  <el-popover placement="top-start" width="400" trigger="hover">
                    <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                  </el-popover>
                  <span>：</span>
                </div>
                <div class="addImgUploadBox">
                  <el-upload
                    class="addImgUpload"
                    :action="uploadPicUrl"
                    :show-file-list="isShowFileList"
                    :data="uploadData"
                    :limit="addImgUploadLimit2"
                    :on-success="clientIdCardAttachmentUploadSuccess"
                    list-type="text"
                    accept="image/*"
                    :on-exceed="exceedFilesNum2"
                    :before-upload="beforeUpload"
                    :file-list="clientIdCardAttachmentImgList"
                    :headers="headers"
                  >
                    <div class="addImgBox">
                      <div class="addImgIcon">
                        <img
                          src="@/assets/images/supplierImg/addImgIcon.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="imgIconTxt">
                      图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                      <span v-show="clientIdCardAttachmentList.length != 0"
                        >（{{ clientIdCardAttachmentList.length }}/2）</span
                      >。
                    </div>
                  </el-upload>
                  <div
                    class="UploadImgList"
                    v-if="clientIdCardAttachmentList.length != 0"
                  >
                    <div
                      class="UploadImgItem"
                      v-for="(
                        FileItem, FileIndex
                      ) in clientIdCardAttachmentList"
                      :key="'FileItem' + FileIndex"
                    >
                      <div class="UploadImgLeft">
                        <div class="UploadItemImg">
                          <img :src="FileItem.url" alt="" />
                        </div>
                        <div class="UploadItemInfo">
                          <div class="UploadItemName">
                            图片{{ FileIndex + 1 }}
                          </div>
                        </div>
                      </div>
                      <div class="UploadImgBtnList">
                        <div
                          @click="handleclientIdCardAttachmentRemove(FileItem)"
                        >
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click="handlePictureCardPreview(FileItem)"
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--法人委托书-->
              <div class="businessBox">
                <div class="certificateTitle">
                  <span>法人委托书</span>
                  <el-popover placement="top-start" width="400" trigger="hover">
                    <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                  </el-popover>
                  <span>：</span>
                </div>
                <div class="addImgUploadBox">
                  <el-upload
                    class="addImgUpload"
                    :action="uploadPicUrl"
                    :show-file-list="isShowFileList"
                    :data="uploadData"
                    :limit="addImgUploadLimit2"
                    :on-success="corporateProxyStatementAttachmentUploadSuccess"
                    list-type="text"
                    accept="image/*"
                    :on-exceed="exceedFilesNum2"
                    :before-upload="beforeUpload"
                    :file-list="corporateProxyStatementAttachmentImgList"
                    :headers="headers"
                  >
                    <div class="addImgBox">
                      <div class="addImgIcon">
                        <img
                          src="@/assets/images/supplierImg/addImgIcon.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="imgIconTxt">
                      图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                      <span
                        v-show="
                          corporateProxyStatementAttachmentList.length != 0
                        "
                        >（{{
                          corporateProxyStatementAttachmentList.length
                        }}/2）</span
                      >。
                    </div>
                  </el-upload>
                  <div
                    class="UploadImgList"
                    v-if="corporateProxyStatementAttachmentList.length != 0"
                  >
                    <div
                      class="UploadImgItem"
                      v-for="(
                        FileItem, FileIndex
                      ) in corporateProxyStatementAttachmentList"
                      :key="'FileItem' + FileIndex"
                    >
                      <div class="UploadImgLeft">
                        <div class="UploadItemImg">
                          <img :src="FileItem.url" alt="" />
                        </div>
                        <div class="UploadItemInfo">
                          <div class="UploadItemName">
                            图片{{ FileIndex + 1 }}
                          </div>
                        </div>
                      </div>
                      <div class="UploadImgBtnList">
                        <div
                          @click="
                            handlecorporateProxyStatementAttachmentRemove(
                              FileItem
                            )
                          "
                        >
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click="handlePictureCardPreview(FileItem)"
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12" style="padding-left: 40px">
              <!--账户信息和开票信息(盖公章)-->
              <div class="businessBox">
                <div class="certificateTitle">
                  <span>账户信息和开票信息(盖公章)</span>
                  <el-popover placement="top-start" width="400" trigger="hover">
                    <!-- <img
                  slot="reference"
                  src="@/assets/images/supplierImg/info-circle-oanticon.png"
                  alt
                /> -->
                  </el-popover>
                  <span>：</span>
                </div>
                <div class="addImgUploadBox">
                  <el-upload
                    class="addImgUpload"
                    :action="uploadPicUrl"
                    :show-file-list="isShowFileList"
                    :data="uploadData"
                    :limit="addImgUploadLimit2"
                    :on-success="
                      accountInformationAndBillingInformationAttachmentUploadSuccess
                    "
                    list-type="text"
                    accept="image/*"
                    :on-exceed="exceedFilesNum2"
                    :before-upload="beforeUpload"
                    :file-list="
                      accountInformationAndBillingInformationAttachmentImgList
                    "
                    :headers="headers"
                  >
                    <div class="addImgBox">
                      <div class="addImgIcon">
                        <img
                          src="@/assets/images/supplierImg/addImgIcon.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="imgIconTxt">
                      图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                      <span
                        v-show="
                          accountInformationAndBillingInformationAttachmentList.length !=
                          0
                        "
                        >（{{
                          accountInformationAndBillingInformationAttachmentList.length
                        }}/2）</span
                      >。
                    </div>
                  </el-upload>
                  <div
                    class="UploadImgList"
                    v-if="
                      accountInformationAndBillingInformationAttachmentList.length !=
                      0
                    "
                  >
                    <div
                      class="UploadImgItem"
                      v-for="(
                        FileItem, FileIndex
                      ) in accountInformationAndBillingInformationAttachmentList"
                      :key="'FileItem' + FileIndex"
                    >
                      <div class="UploadImgLeft">
                        <div class="UploadItemImg">
                          <img :src="FileItem.url" alt="" />
                        </div>
                        <div class="UploadItemInfo">
                          <div class="UploadItemName">
                            图片{{ FileIndex + 1 }}
                          </div>
                        </div>
                      </div>
                      <div class="UploadImgBtnList">
                        <div
                          @click="
                            handleaccountInformationAndBillingInformationAttachmentRemove(
                              FileItem
                            )
                          "
                        >
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click="handlePictureCardPreview(FileItem)"
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="businessBox">
                <div class="certificateTitle">
                  <span>其他材料1</span>
                  <el-popover placement="top-start" width="400" trigger="hover">
                    <div>
                      <div>
                        需提交特殊产品资质的类目请将资质上传在此处，包括全国工业生产许可证、3C、医疗器械生产许可证、化妆品生产企业卫生许可证等，根据具体类目资质要求提交。
                      </div>
                    </div>
                  </el-popover>
                  <span>：</span>
                </div>
                <div class="addImgUploadBox">
                  <el-upload
                    class="addImgUpload"
                    :action="uploadPicUrl"
                    :show-file-list="isShowFileList"
                    :data="uploadData"
                    :limit="addImgUploadLimit2"
                    :on-success="restsUploadSuccess1"
                    list-type="text"
                    accept="image/*"
                    :on-exceed="exceedFilesNum2"
                    :before-upload="beforeUpload"
                    :file-list="restsFileImgList1"
                    :headers="headers"
                  >
                    <div class="addImgBox">
                      <div class="addImgIcon">
                        <img
                          src="@/assets/images/supplierImg/addImgIcon.png"
                          alt
                        />
                      </div>
                    </div>
                    <div class="imgIconTxt">
                      图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                      <span v-show="restsFileList1.length != 0"
                        >（{{ restsFileList1.length }}/2）</span
                      >。
                    </div>
                  </el-upload>
                  <div class="UploadImgList" v-if="restsFileList1.length != 0">
                    <div
                      class="UploadImgItem"
                      v-for="(restsFileItem, restsFileIndex) in restsFileList1"
                      :key="'restsFileItem' + restsFileIndex"
                    >
                      <div class="UploadImgLeft">
                        <div class="UploadItemImg">
                          <img :src="restsFileItem.url" alt />
                        </div>
                        <div class="UploadItemInfo">
                          <div class="UploadItemName">
                            图片{{ restsFileIndex + 1 }}
                          </div>
                        </div>
                      </div>
                      <div class="UploadImgBtnList">
                        <div @click="handleRestsRemove1(restsFileItem)">
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click="handlePictureCardPreview(restsFileItem)"
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12" style="padding-left: 40px">
              <!--其他材料2-->
              <div class="businessBox">
                <div class="certificateTitle">
                  <span>其他材料2</span>
                  <el-popover placement="top-start" width="400" trigger="hover">
                    <div>
                      <div>
                        需提交特殊产品资质的类目请将资质上传在此处，包括全国工业生产许可证、3C、医疗器械生产许可证、化妆品生产企业卫生许可证等，根据具体类目资质要求提交。
                      </div>
                    </div>
                  </el-popover>
                  <span>：</span>
                </div>
                <div class="addImgUploadBox">
                  <el-upload
                    class="addImgUpload"
                    :action="uploadPicUrl"
                    :show-file-list="isShowFileList"
                    :data="uploadData"
                    :limit="addImgUploadLimit2"
                    :on-success="restsUploadSuccess2"
                    list-type="text"
                    accept="image/*"
                    :on-exceed="exceedFilesNum2"
                    :before-upload="beforeUpload"
                    :file-list="restsFileImgList2"
                    :headers="headers"
                  >
                    <div class="addImgBox">
                      <div class="addImgIcon">
                        <img
                          src="@/assets/images/supplierImg/addImgIcon.png"
                          alt
                        />
                      </div>
                    </div>
                    <div class="imgIconTxt">
                      图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                      <span v-show="restsFileList2.length != 0"
                        >（{{ restsFileList2.length }}/2）</span
                      >。
                    </div>
                  </el-upload>
                  <div class="UploadImgList" v-if="restsFileList2.length != 0">
                    <div
                      class="UploadImgItem"
                      v-for="(restsFileItem, restsFileIndex) in restsFileList2"
                      :key="'restsFileItem' + restsFileIndex"
                    >
                      <div class="UploadImgLeft">
                        <div class="UploadItemImg">
                          <img :src="restsFileItem.url" alt />
                        </div>
                        <div class="UploadItemInfo">
                          <div class="UploadItemName">
                            图片{{ restsFileIndex + 1 }}
                          </div>
                        </div>
                      </div>
                      <div class="UploadImgBtnList">
                        <div @click="handleRestsRemove2(restsFileItem)">
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click="handlePictureCardPreview(restsFileItem)"
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!--其他材料3-->
              <div class="businessBox">
                <div class="certificateTitle">
                  <span>其他材料3</span>
                  <el-popover placement="top-start" width="400" trigger="hover">
                    <div>
                      <div>
                        需提交特殊产品资质的类目请将资质上传在此处，包括全国工业生产许可证、3C、医疗器械生产许可证、化妆品生产企业卫生许可证等，根据具体类目资质要求提交。
                      </div>
                    </div>
                  </el-popover>
                  <span>：</span>
                </div>
                <div class="addImgUploadBox">
                  <el-upload
                    class="addImgUpload"
                    :action="uploadPicUrl"
                    :show-file-list="isShowFileList"
                    :data="uploadData"
                    :limit="addImgUploadLimit2"
                    :on-success="restsUploadSuccess3"
                    list-type="text"
                    accept="image/*"
                    :on-exceed="exceedFilesNum2"
                    :before-upload="beforeUpload"
                    :file-list="restsFileImgList3"
                    :headers="headers"
                  >
                    <div class="addImgBox">
                      <div class="addImgIcon">
                        <img
                          src="@/assets/images/supplierImg/addImgIcon.png"
                          alt
                        />
                      </div>
                    </div>
                    <div class="imgIconTxt">
                      图片大小1M以内 支持.jpg .jpeg .png 格式 最多上传2张
                      <span v-show="restsFileList3.length != 0"
                        >（{{ restsFileList3.length }}/2）</span
                      >。
                    </div>
                  </el-upload>
                  <div class="UploadImgList" v-if="restsFileList3.length != 0">
                    <div
                      class="UploadImgItem"
                      v-for="(restsFileItem, restsFileIndex) in restsFileList3"
                      :key="'restsFileItem' + restsFileIndex"
                    >
                      <div class="UploadImgLeft">
                        <div class="UploadItemImg">
                          <img :src="restsFileItem.url" alt />
                        </div>
                        <div class="UploadItemInfo">
                          <div class="UploadItemName">
                            图片{{ restsFileIndex + 1 }}
                          </div>
                        </div>
                      </div>
                      <div class="UploadImgBtnList">
                        <div @click="handleRestsRemove3(restsFileItem)">
                          删除
                        </div>
                        <div
                          class="previewBtn"
                          @click="handlePictureCardPreview(restsFileItem)"
                        >
                          预览
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>

          <!-- <div class="btnList">
          <el-button class="backBtn" type="primary" @click="goBack()">取消</el-button>
          <el-button class="nextBtn" type="primary" @click="submitBtn()">提交</el-button>
          </div>-->
        </div>

        <div class="AddSupplierATitle">审批信息</div>
        <div class="AddSupplierAContent">
          <el-row>
            <el-col :span="24">
              <el-row>
                <div class="time-box">
                  <div
                    class="item"
                    v-for="(item, index) in ruleForm.typeRelList"
                    :key="index"
                  >
                    <div class="left">
                      <el-col :span="10">
                        <el-form-item
                          :label="'合作单位分类' + (index + 1) + '：'"
                          :prop="'typeRelList.' + index + '.topId'"
                          :rules="rules['topId']"
                        >
                          <el-select
                            v-model="item.topId"
                            placeholder="请选择一级分类"
                            filterable
                            @change="firstSupplierTypeChange(item.topId, index)"
                          >
                            <el-option
                              :label="supplier.typeValue"
                              :value="supplier.id"
                              v-for="supplier in firstSupplierTypeList"
                              :key="supplier.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <!-- <el-form-item label="" label-width="20px" :prop="'typeRelList.' + index + '.secondId'" :rules='rules["secondId"]'> -->
                        <el-form-item label="" label-width="20px">
                          <el-select
                            v-model="item.secondId"
                            filterable
                            default-first-option
                            placeholder="请选择二级分类"
                            @change="
                              secondSupplierTypeChange(item.secondId, index)
                            "
                          >
                            <el-option
                              :label="supplier.typeValue"
                              :value="supplier.id"
                              v-for="supplier in secondSupplierTypeList[index]"
                              :key="supplier.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <!-- <el-form-item
                          class="noMarginBottom"
                          label
                          label-width="20px"
                          :prop="'typeRelList.' + index + '.thirdId'"
                          :rules='rules["thirdId"]'
                        > -->
                        <el-form-item
                          class="noMarginBottom"
                          label
                          label-width="20px"
                        >
                          <el-select
                            v-model="item.thirdId"
                            filterable
                            default-first-option
                            placeholder="请选择三级分类"
                          >
                            <el-option
                              :label="supplier.typeValue"
                              :value="supplier.id"
                              v-for="supplier in thirdSupplierTypeList[index]"
                              :key="supplier.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </div>
                    <div class="right">
                      <el-button
                        v-if="index == 0"
                        @click="addDevPlatTypeList"
                        size="small"
                        icon="el-icon-circle-plus"
                      ></el-button>
                      <el-button
                        v-if="index != 0"
                        @click="delDevPlatTypeList(index)"
                        size="small"
                        icon="el-icon-remove"
                      ></el-button>
                    </div>
                    <!-- <div class="right del" @click="delDevPlatTypeList(index)">删除</div> -->
                  </div>
                </div>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item class="noMarginBottom" label="是否置顶：">
                <el-col style="padding-left: 20px" :span="8">
                  <el-checkbox
                    v-model="checkedone"
                    style="width: 100px"
                    label="1"
                    @change="handleCheckChange(0)"
                    >不置顶</el-checkbox
                  >
                </el-col>
                <el-col style="padding-left: 60px" :span="8">
                  <el-checkbox
                    v-model="checkedtwo"
                    style="width: 100px"
                    label="1"
                    @change="handleCheckChange(1)"
                    >置顶</el-checkbox
                  >
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="9">
              <el-form-item label="审批流：" prop="approveTemplateType">
                <el-select
                  v-model="ruleForm.approveTemplateType"
                  filterable
                  default-first-option
                  placeholder="请选择"
                  @change="changeapproveTemplateType()"
                >
                  <el-option
                    :label="item.value"
                    :value="item.label"
                    v-for="item in approveTemplate"
                    :key="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row style="padding: left -16px;">
            <el-col :span="16">
            <approveLine
              :addoredit="editFlag"
              :itemId="supplierId"
              @saveApproveType="saveApproveType"
              @saveApproveLine="saveApproveLine"
              :approveType="approveType"
              :approveClass="approveClass"
              :subApproveType="ruleForm.approveTemplateType || approveType"
              :subApproveName="ruleForm.approveTemplateName || ''"
            ></approveLine>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div class="bottomBtn">
        <el-button type="primary" @click="submitBtn('ruleForm')"
          >保 存</el-button
        >
        <el-button type="info" @click="goBack">取 消</el-button>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      class="imgMaskDialog"
      title="预览图片"
    >
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
// import esoterica from './esoterica';  //快速通过审核秘籍
// import { getUploadUrl } from "../../../services/commonService";
// import {
//   checkShopNameServer,
//   saveDetailService,
// } from "../../../services/merchantsIn";saveSupplierBInfo
import {
  getSupplierADetailService, //查询一条甲方供应商
  updateSupplierBInfo, //更新一条乙方供应商
  uploadSupplierFilesService, //上传文件接口
  saveSupplierBInfo, //保存供应商接口
  getSupplierTypeList, //获取供应商一级类别列表接口
  getSuppliersubTypeList, //查询子类别列表接口
  updateSupplierStatus,
} from "../../../services/supplierMagServices";
import {
  getRealApproveListService, //查询审批列表
  saveSupplierApproveService,
} from "../../../services/approveServices";
import {
  selectSecondDataDetailService, //获取二级数据字典内容
} from "@/services/sysSettingService";
import {
  getTempUrlService, //下载附件
} from "@/services/allContractServices";
import config from "@/common/config";
import approveLine from "../../approveComponents/NewApproveLine"; //新增审批流程
export default {
  name: "AddSupplierBSelf",
  components: {
    approveLine,
  },
  data() {
    return {
      editFlag: false,
      approveType: "supplier",
      approveClass: "SUPPLIER", //审批类型
      ApproveList: [], //审批流数据
      RouteParam: {}, //存储路由跳转参数
      supplierId: 0, //总包合同ID
      dialogVisible: false, //预览图片是否异步
      dialogImageUrl: "", //预览图片的路径
      uploadLimit: 1, //拖拽上传最多一张图片
      addImgUploadLimit: 10, //添加上传最多三十张图片
      addImgUploadLimit2: 2, //添加上传最多5张图片
      isShowFileList: false, //是否显示上传成功的列表
      firstSupplierTypeList: [], //一级供应商分类列表
      secondSupplierTypeList: [], //一级供应商分类列表
      thirdSupplierTypeList: [], //一级供应商分类列表
      uploadData: {
        //上传图片的参数
        // source: "merchantPC",
        // business: "shopPic"
      },
      uploadPicUrl: config.baseUrl + "/appuser-web/oss/upload/supplier/pic", //上传图片地址
      triangleFileList: [], //营业执照上传图片成功的数据---三证合一
      triangleFileImgList: [], //营业执照
      cosmeticSanitationFileList: [], //资质证明图片数组
      cosmeticSanitationFileImgList: [], //资质证明
      safetyProductionLicenseAttachmentList: [], //安全生产许可证(通过年审)附件列表
      safetyProductionLicenseAttachmentImgList: [], //安全生产许可证(通过年审)
      laborQualificationAttachmentList: [], //劳务资质证书(通过年审)附件列表
      laborQualificationAttachmentImgList: [], //劳务资质证书(通过年审)
      corporateIdCardAttachmentList: [], //法人身份证附件列表
      corporateIdCardAttachmentImgList: [], //法人身份证
      clientIdCardAttachmentList: [], //委托人身份证附件列表
      clientIdCardAttachmentImgList: [], //委托人身份证
      corporateProxyStatementAttachmentList: [], //法人委托书附件列表
      corporateProxyStatementAttachmentImgList: [], //法人委托书附件列表
      accountInformationAndBillingInformationAttachmentList: [], //账户信息和开票信息(盖公章)
      accountInformationAndBillingInformationAttachmentImgList: [], //账户信息和开票信息(盖公章)

      restsFileList1: [], //其他材料图片数组
      restsFileImgList1: [], //其他资料
      restsFileList2: [], //其他材料图片数组
      restsFileImgList2: [], //其他资料
      restsFileList3: [], //其他材料图片数组
      restsFileImgList3: [], //其他资料

      checkedone: true,
      checkedtwo: false, //默认不置顶

      selectTemplateItems:{}, //选择的审批流模板

      signinAddress: {
        //注册地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      },
      businessAddress: {
        //办公地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      },
      openingBankAddress: {
        //开户行地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      },

      enterpriseIcon: {
        selectIcon: require("@/assets/images/supplierImg/select.png"),
        selectActiveIcon: require("@/assets/images/supplierImg/selectActive.png"),
      },
      ruleForm: {
        companyName: "", //公司名称
        contactEmail: "", //联系人邮箱
        contactFax: "", //联系人传真
        contactName: "", //联系人姓名
        contactPhone: "", //联系人电话
        legalPerson: "", //法人
        businessLicenseAttachmentList: [], //营业执照正本(通过年审)附件列表
        qualificationAttachmentList: [], //资质证书(通过年审)附件列表
        safetyProductionLicenseAttachmentList: [], //安全生产许可证(通过年审)附件列表
        laborQualificationAttachmentList: [], //劳务资质证书(通过年审)附件列表
        corporateIdCardAttachmentList: [], //法人身份证附件列表
        clientIdCardAttachmentList: [], //委托人身份证附件列表
        corporateProxyStatementAttachmentList: [], //法人委托书附件列表
        accountInformationAndBillingInformationAttachmentList: [], //账户信息和开票信息(盖公章)
        other1AttachmentList: [], //其他材料1图片地址
        other2AttachmentList: [], //其他材料2图片地址
        other3AttachmentList: [], //其他材料3图片地址
        publicBank: "", //对外开户行
        publicBankAccount: "", //对外账号
        publicBankAddress: "", //对外开户行地址
        publicBankNumber: "", //对外开户行行号
        publicCompanyName: "", //对外公司名称
        publicTaxAccount: "", //对外税号
        registeAddress: "", //注册地址
        workAddress: "", //办公地址
        workPhone: "", //办公电话
        publicPhone: "", //对外对公户电话
        // billAddress: "", //开票单位地址
        // billBank: "", //开票开户银行
        // billBankNumber: "", //开票开户行号
        // billHead: "", //开票抬头
        // billTaxNumber: "", //开票纳税人识别号
        topId: "", //一级分类
        secondId: "", //二级分类
        thirdId: "", //三级级分类
        topType: "bType", //aType 甲方供应商 bType乙方供应商
        approveStatus: 0, //供应商保存 0  提交审核 1
        approveTemplateName:'', // 模板名称
        approveTemplateType:'', // 模板类型
        approveTemplate: [], //审批流类型查询
        typeRelList: [
          {
            topId: 2, //一级分类
            secondId: "", //二级分类
            thirdId: "", //三级级分类
          },
        ], //合作单位分类数组
        approveProcessCreateDtoList: [], //审批流人员信息
      },
      rules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z0-9（）]+$/,
            message: "请输入正确的公司名称",
            trigger: "change",
          },
        ],
        publicCompanyName: [
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z0-9（）]+$/,
            message: "请输入正确的公司名称",
          },
          // {pattern:/^(?!.*\（\（)(?!.*\）\）)(?!.*\-\-)(?!.*\+\+)(?!.*\·\·)[\u4E00-\u9FA5A-Za-z0-9\（\）\-\+\·]{1,99}$/,message:'店铺名称只允许使用中文、英文、数字（）-+·'}
        ],

        publicPhone: [
          {
            pattern: /^([0-9-]+)$/,
            message: "请输入正确的对公户电话",
            trigger: "change",
          },
        ],
        registeAddress: [
          { required: true, message: "请输入注册地址", trigger: "blur" },
        ],
        workAddress: [
          { required: true, message: "请输入办公地址", trigger: "blur" },
        ],
        topId: [
          { required: true, message: "请选择一级分类", trigger: "change" },
        ],
        secondId: [
          { required: true, message: "请选择二级分类", trigger: "change" },
        ],
        thirdId: [
          { required: true, message: "请选择三级分类", trigger: "change" },
        ],
        publicTaxAccount: [
          // {
          //   message: "只能输入数字",
          //   type: "number",
          //   trigger: "change",
          //   transform: (value) => Number(value),
          // },
        ],
        legalPerson: [
          { required: true, message: "请输入法人姓名", trigger: "blur" },
          {
            min: 2,
            max: 60,
            message: "姓名长度在 2 到 60 个字符",
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z\u4e00-\u9fa5]+$/,
            message: "请输入正确的法人姓名",
            trigger: "change",
          },
        ],
        workPhone: [
          { required: true, message: "请输入办公电话", trigger: "blur" },
          {
            pattern: /^([0-9-]+)$/,
            message: "请输入正确的办公电话",
            trigger: "change",
          },
          // {
          //     message: "请输入正确的办公电话",
          //     type: "number",
          //     transform: value => Number(value),
          // },
        ],
        contactName: [
          {
            min: 2,
            max: 12,
            message: "姓名长度在 2 到 12 个字符",
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z\u4e00-\u9fa5]+$/,
            message: "请输入正确的联系人姓名",
            trigger: "change",
          },
        ],
        contactPhone: [
          {
            pattern:
              /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(16[0-9]{1}))+\d{8})$/,
            message: "请输入正确的联系人手机",
            trigger: "change",
          },
        ],
        contactEmail: [
          {
            type: "email",
            message: "请输入正确的联系人邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      isShopNameBool: false,
    };
  },
  props: {
    shopInfoData: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    shopInfoData(val) {
      if (val != null) {
        this.init();
      }
    },
  },
  computed: {
    headers() {
      return {
        Authorization: sessionStorage.getItem("accessToken"),
      };
    },
  },
  mounted() {
    this.uploadPicUrl = config.baseUrl + "/appuser-web/oss/upload/supplier/pic"; //getUploadUrl();
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.editFlag = this.tabRouteParam ? this.tabRouteParam.editFlag : false;
      this.RouteParam = this.tabRouteParam;
      this.getSupplierTypeList(); //获取一级分类下拉列表
      // this.getApproveTempData();
      if (this.editFlag) {
        //编辑 获取一条供应商信息
        this.supplierId = this.tabRouteParam.id;
        this.getSupplierDetail(this.supplierId);
      } else {
        this.getsubSupplierTypeList(2, 0, 2);
        this.ruleForm.topType = this.tabRouteParam
          ? this.tabRouteParam.topType
          : "bType";
      }
    },
    //获取一条信息
    getSupplierDetail(supplierId) {
      if (this.RouteParam) {
        let param = {};
        param.supplierId = supplierId;
        getSupplierADetailService(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.ruleForm = res.data;
              this.ruleForm.approveProcessCreateDtoList = [];
              if (this.ruleForm.isTop == 1) {
                this.checkedtwo = true;
                this.checkedone = false;
              }
              // this.getSuppliersApproveList(); //获取审批流数据
              this.init();
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    //获取一级供应商分类列表
    getSupplierTypeList() {
      let reqParam = {
        pageIndex: "1",
        pageSize: "50",
      };
      getSupplierTypeList().then(
        (res) => {
          if (res.code == 10000000) {
            this.firstSupplierTypeList = res.data;
            // this.getSupplierDetail(this.supplierId);
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error("系统异常");
        }
      );
    },
    //获取下级供应商分类列表
    getsubSupplierTypeList(val, index, typeLevel) {
      let param = {};
      param.supplierTypeId = val;
      getSuppliersubTypeList(param)
        .then((res) => {
          if (res.code == 10000000) {
            if (typeLevel == 2) {
              this.secondSupplierTypeList[index] = res.data;
              this.$forceUpdate();

              this.ruleForm.typeRelList[index].secondId =
                this.ruleForm.typeRelList[index].secondId ?? "";
            } else {
              this.thirdSupplierTypeList[index] = res.data;
              this.$forceUpdate();

              this.ruleForm.typeRelList[index].thirdId =
                this.ruleForm.typeRelList[index].thirdId ?? "";
            }
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {
          this.$message.error("系统异常");
        });
    },
    //选择完一级分类获取二级分类
    firstSupplierTypeChange(val, index) {
      // this.secondSupplierTypeList[index] = [];
      // this.thirdSupplierTypeList[index] = [];
      this.ruleForm.typeRelList[index].secondId = "";
      this.ruleForm.typeRelList[index].thirdId = "";
      this.getsubSupplierTypeList(val, index, 2);
    },
    //选择完二级分类获取三级分类
    secondSupplierTypeChange(val, index) {
      // this.thirdSupplierTypeList[index] = [];
      this.ruleForm.typeRelList[index].thirdId = "";
      this.getsubSupplierTypeList(val, index, 3);
    },
    /**
     * 新增a一行数据分类
     */
    addDevPlatTypeList() {
      let len = this.ruleForm.typeRelList.length;
      if (len == 4) {
        this.$alert("最多添加四条分类信息", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      for (let i = 0; i < len; i++) {
        let val = this.ruleForm.typeRelList[i];
        if (val.topId == "") {
          this.$alert("有未选择的一级分类", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }
        // if (val.secondId == "") {
        //   this.$alert("有未选择的二级分类", "提示", {
        //     confirmButtonText: "确定"
        //   });
        //   return;
        // }
        // if (val.thirdId == "") {
        //   this.$alert("有未选择的三级分类", "提示", {
        //     confirmButtonText: "确定"
        //   });
        //   return;
        // }
      }

      this.ruleForm.typeRelList.push({
        topId: "",
        secondId: "",
        thirdId: "",
      });
    },
    /**
     * 删除一条数据分类
     */
    delDevPlatTypeList(index) {
      this.ruleForm.typeRelList.splice(index, 1);
    },
    //获取审批信息列表
    getSuppliersApproveList() {
      let param = {};
      param.itemId = this.supplierId; //供应商id
      param.approveClass = "SUPPLIER"; //类型：供应商
      getRealApproveListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.ApproveList = res.data; //审批流模板
            this.ruleForm.approveProcessCreateDtoList = res.data;
            this.approveType = this.ruleForm.approveTemplateType;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },
    //删除图片
    closeBtnClick(closeIndex) {
      if (closeIndex == 1) {
        this.triangleFileList = [];
        this.ruleForm.licenseAttachmentList.splice(0, 1);
      } else if (closeIndex == 2) {
        this.identitycardFrontFileList = [];
        this.ruleForm.idCardAttachmentList.splice(0, 1);
      } else if (closeIndex == 3) {
        this.identitycardReverseFileList = [];
        this.ruleForm.idCardAttachmentList.splice(1, 1);
      } else if (closeIndex == 4) {
        this.triangleFileList1 = [];
        this.ruleForm.licenseAttachmentList.splice(1, 1);
      } else if (closeIndex == 5) {
        this.openAccountFileList = [];
      }
    },
    //预览图片
    previewBtnClick(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    publicTaxAccountInput(value) {
      this.ruleForm.publicTaxAccount = value.replace(/[^A-Za-z0-9]/g, "");
    },
    // publicbillTaxNumberInput(value) {
    //   this.ruleForm.billTaxNumber = value.replace(/[^A-Za-z0-9]/g, "");
    // },
    setIsShowHelpExplain(index) {
      this.$emit("setIsShowHelpExplain", index);
    },
    shopNameBlur() {
      if (!this.ruleForm.shopName) {
        return;
      }
      let params = {
        shopName: this.ruleForm.shopName,
        shopCode: sessionStorage.getItem("shopCode"),
      };
      // checkShopNameServer(params).then(res => {
      //   if (res.resultCode == 0) {
      //     this.isShopNameBool = res.data;
      //     if (res.data) {
      //       this.$message.error("店铺名称重复");
      //     }
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // });
    },
    //存储审批流
    saveApproveLine(selectItems) {
      this.ruleForm.approveProcessCreateDtoList = selectItems;
      // this.ruleForm.approveProcessCreateDtoList.approveUserName = selectItems.approveUserName;
      // this.ruleForm.approveProcessCreateDtoList.deptId = selectItems.deptId;
      // this.ruleForm.approveProcessCreateDtoList.sort = selectItems.sort;
      // this.dialogForm.contractItemVOs = selectItems;
    },
    emptyHistoryData() {
      this.$refs["ruleForm"].resetFields();
      this.isShopNameBool = false;
      this.triangleFileList = []; //上传图片成功的数据---三证合一
      this.identitycardFrontFileList = []; //身份证正面
      this.identitycardReverseFileList = []; //身份证反面
      this.taxpayerFileList = []; //纳税人资格证
      this.brandFileList = []; //商标图片数组
      this.brandFileImgList = [];
      this.qualityFileList = []; //质检图片数组
      this.qualityFileImgList = [];
      this.restsFileList = []; //其他资质数组
      this.restsFileImgList = [];
      this.openAccountFileList = []; //开户许可图片
      this.signinAddress = {
        //注册地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      };
      this.businessAddress = {
        //办公地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      };
      this.openingBankAddress = {
        //开户行地址数据
        province: "", //省
        city: "", //市
        district: "", //区
        detailedAddress: "", //详细地址
      };
    },
     //存储审批流模板类型
     saveApproveType(item) {
      this.ruleForm.approveTemplateType = item.label;
      this.ruleForm.approveTemplateName = item.value;
    },

    //获取审批流模板数据
    getApproveTempData(data) {
      let params = {};
      // params.dictId = this.dictId;
      params.label = 'supplier';
      selectSecondDataDetailService(params)
        .then(
          (res) => {
            if (res.code == 10000000) {
              this.approveTemplate = res.data;
            } else {
              this.$alert(res.msg, "提示");
            }
          },
          (err) => {
            this.$message.error("系统异常");
          }
        )
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },
    //初始化数据
    init() {
      if (
        null == this.ruleForm.typeRelList ||
        this.ruleForm.typeRelList.length == 0
      ) {
        this.ruleForm.typeRelList = [];
        this.ruleForm.typeRelList.push({
          secondId: "",
          thirdId: "",
          topId: 1,
        });
      } else {
        let len = this.ruleForm.typeRelList.length;
        if (len > 0) {
          for (let i = 0; i < len; i++) {
            if (this.ruleForm.typeRelList[i].topId) {
              let topId = this.ruleForm.typeRelList[i].topId;
              this.getsubSupplierTypeList(topId, i, 2);
            }
            if (this.ruleForm.typeRelList[i].secondId) {
              let secondId = this.ruleForm.typeRelList[i].secondId;
              this.getsubSupplierTypeList(secondId, i, 3);
            }
          }
        }
      }

      this.triangleFileList = [];
      this.safetyProductionLicenseAttachmentList = []; //安全涩生产许可证
      this.laborQualificationAttachmentList = []; //劳务资质证书
      this.cosmeticSanitationFileList = []; //资质证明图片地址
      this.corporateIdCardAttachmentList = []; //法人身份证附件列表

      this.clientIdCardAttachmentList = []; //委托人身份证附件列表
      this.corporateProxyStatementAttachmentList = []; //法人委托书附件列表
      this.accountInformationAndBillingInformationAttachmentList = []; //账户信息和开票信息(盖公章)

      this.restsFileList1 = []; //其他材料1图片数组
      this.restsFileList2 = []; //其他材料2图片数组
      this.restsFileList3 = []; //其他材料2图片数组

      this.triangleFileImgList = [];
      this.safetyProductionLicenseAttachmentImgList = []; //安全涩生产许可证
      this.laborQualificationAttachmentImgList = []; //劳务资质证书
      this.cosmeticSanitationFileImgList = []; //资质证明图片地址
      this.corporateIdCardAttachmentImgList = []; //法人身份证附件列表

      this.clientIdCardAttachmentImgList = []; //委托人身份证附件列表
      this.corporateProxyStatementAttachmentImgList = []; //法人委托书附件列表
      this.accountInformationAndBillingInformationAttachmentImgList = []; //账户信息和开票信息(盖公章)

      this.restsFileImgList1 = []; //其他材料1图片数组
      this.restsFileImgList2 = []; //其他材料2图片数组
      this.restsFileImgList3 = []; //其他材料2图片数组

      this.isShopNameBool = false;
      //资质证明
      if (this.ruleForm.qualificationAttachmentList) {
        let len = this.ruleForm.qualificationAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.cosmeticSanitationFileList.push({
            url: this.ruleForm.qualificationAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.cosmeticSanitationFileImgList.push({
            url: this.ruleForm.qualificationAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.qualificationAttachmentList = [];
      }
      //营业执照正本
      if (this.ruleForm.businessLicenseAttachmentList) {
        let len = this.ruleForm.businessLicenseAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.triangleFileList.push({
            url: this.ruleForm.businessLicenseAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.triangleFileImgList.push({
            url: this.ruleForm.businessLicenseAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.businessLicenseAttachmentList = [];
      }

      //安全生产许可正
      if (this.ruleForm.safetyProductionLicenseAttachmentList) {
        let len = this.ruleForm.safetyProductionLicenseAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.safetyProductionLicenseAttachmentList.push({
            url: this.ruleForm.safetyProductionLicenseAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.safetyProductionLicenseAttachmentImgList.push({
            url: this.ruleForm.safetyProductionLicenseAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.safetyProductionLicenseAttachmentList = [];
      }

      //劳务资质证书
      if (this.ruleForm.laborQualificationAttachmentList) {
        let len = this.ruleForm.laborQualificationAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.laborQualificationAttachmentList.push({
            url: this.ruleForm.laborQualificationAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.laborQualificationAttachmentImgList.push({
            url: this.ruleForm.laborQualificationAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.laborQualificationAttachmentList = [];
      }

      //法人身份证
      if (this.ruleForm.corporateIdCardAttachmentList) {
        let len = this.ruleForm.corporateIdCardAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.corporateIdCardAttachmentList.push({
            url: this.ruleForm.corporateIdCardAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.corporateIdCardAttachmentImgList.push({
            url: this.ruleForm.corporateIdCardAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.corporateIdCardAttachmentList = [];
      }

      //委托人身份证
      if (this.ruleForm.clientIdCardAttachmentList) {
        let len = this.ruleForm.clientIdCardAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.clientIdCardAttachmentList.push({
            url: this.ruleForm.clientIdCardAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.clientIdCardAttachmentImgList.push({
            url: this.ruleForm.clientIdCardAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.clientIdCardAttachmentList = [];
      }

      //法人委托书
      if (this.ruleForm.corporateProxyStatementAttachmentList) {
        let len = this.ruleForm.corporateProxyStatementAttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.corporateProxyStatementAttachmentList.push({
            url: this.ruleForm.corporateProxyStatementAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.corporateProxyStatementAttachmentImgList.push({
            url: this.ruleForm.corporateProxyStatementAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.corporateProxyStatementAttachmentList = [];
      }

      //账户信息和开票信息
      if (this.ruleForm.accountInformationAndBillingInformationAttachmentList) {
        let len =
          this.ruleForm.accountInformationAndBillingInformationAttachmentList
            .length;
        for (let i = 0; i < len; i++) {
          this.accountInformationAndBillingInformationAttachmentList.push({
            url: this.ruleForm
              .accountInformationAndBillingInformationAttachmentList[i]
              .attachmentItemDisplay,
          });
          this.accountInformationAndBillingInformationAttachmentImgList.push({
            url: this.ruleForm
              .accountInformationAndBillingInformationAttachmentList[i]
              .attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.accountInformationAndBillingInformationAttachmentList =
          [];
      }

      if (this.ruleForm.other1AttachmentList) {
        let len = this.ruleForm.other1AttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.restsFileList1.push({
            url: this.ruleForm.other1AttachmentList[i].attachmentItemDisplay,
          });
          this.restsFileImgList1.push({
            url: this.ruleForm.other1AttachmentList[i].attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.other1AttachmentList = [];
      }
      if (this.ruleForm.other2AttachmentList) {
        let len = this.ruleForm.other2AttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.restsFileList2.push({
            url: this.ruleForm.other2AttachmentList[i].attachmentItemDisplay,
          });
          this.restsFileImgList2.push({
            url: this.ruleForm.other2AttachmentList[i].attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.other2AttachmentList = [];
      }
      if (this.ruleForm.other3AttachmentList) {
        let len = this.ruleForm.other3AttachmentList.length;
        for (let i = 0; i < len; i++) {
          this.restsFileList3.push({
            url: this.ruleForm.other3AttachmentList[i].attachmentItemDisplay,
          });
          this.restsFileImgList3.push({
            url: this.ruleForm.other3AttachmentList[i].attachmentItemDisplay,
          });
        }
      } else {
        this.ruleForm.other3AttachmentList = [];
      }
    },

    setRuleFormLongTime() {
      this.ruleForm.longTime = !this.ruleForm.longTime;
      if (this.ruleForm.longTime) {
        this.ruleForm.validityTime = [];
      }
    },
    fileChanged(file, fileList) {
      console.log(file);
    },
    uploadFaildAction(err, file, fileList) {
      this.$message.error(err.msg);
    },

    exceedFilesNum2() {
      this.$alert("最多上传2张图片"),
        "错误",
        {
          confirmButtonText: "确定",
        };
    },

    //上传营业执照正本(通过年审)附件列表
    triangleUploadSuccess(res, file, list) {
      if (res.code == 10000000) {
        let reqParam = {
          filePath: res.data.path,
        };
        this.ruleForm.businessLicenseAttachmentList.push({
          attachmentItem: res.data.path,
        });

        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件

              this.triangleFileList.push({ url: res.data });
              this.triangleFileImgList = list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        this.$alert("营业执照正本(通过年审)上传失败");
      }
    },

    //上传一个资质证书(通过年审)附件列表
    cosmeticSanitationUploadSuccess(res, file, list) {
      if (res.code == 10000000) {
        this.ruleForm.qualificationAttachmentList.push({
          attachmentItem: res.data.path,
        });
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.cosmeticSanitationFileList.push({ url: res.data });
              this.cosmeticSanitationFileImgList = list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("资质证明照片上传失败");
      }
    },

    //上传一个安全生产许可证(有效期内)附件列表
    safetyProductionLicenseAttachmentUploadSuccess(res, file, list) {
      if (res.code == 10000000) {
        this.ruleForm.safetyProductionLicenseAttachmentList.push({
          attachmentItem: res.data.path,
        });
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.safetyProductionLicenseAttachmentList.push({
                url: res.data,
              });
              this.safetyProductionLicenseAttachmentImgList = list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("资质证明照片上传失败");
      }
    },

    //上传一个劳务资质证书附件列表
    laborQualificationAttachmentUploadSuccess(res, file, list) {
      if (res.code == 10000000) {
        this.ruleForm.laborQualificationAttachmentList.push({
          attachmentItem: res.data.path,
        });
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.laborQualificationAttachmentList.push({ url: res.data });
              this.laborQualificationAttachmentImgList = list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("资质证明照片上传失败");
      }
    },

    //上传一个法人身份证附件列表
    corporateIdCardAttachmentUploadSuccess(res, file, list) {
      if (res.code == 10000000) {
        this.ruleForm.corporateIdCardAttachmentList.push({
          attachmentItem: res.data.path,
        });
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.corporateIdCardAttachmentList.push({ url: res.data });
              this.corporateIdCardAttachmentImgList = list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("资质证明照片上传失败");
      }
    },

    //上传一个委托人身份证附件列表
    clientIdCardAttachmentUploadSuccess(res, file, list) {
      if (res.code == 10000000) {
        this.ruleForm.clientIdCardAttachmentList.push({
          attachmentItem: res.data.path,
        });
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.clientIdCardAttachmentList.push({ url: res.data });
              this.clientIdCardAttachmentImgList = list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("资质证明照片上传失败");
      }
    },

    //上传一个法人委托书附件列表
    corporateProxyStatementAttachmentUploadSuccess(res, file, list) {
      if (res.code == 10000000) {
        this.ruleForm.corporateProxyStatementAttachmentList.push({
          attachmentItem: res.data.path,
        });
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.corporateProxyStatementAttachmentList.push({
                url: res.data,
              });
              this.corporateProxyStatementAttachmentImgList = list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("资质证明照片上传失败");
      }
    },

    //上传一个账户信息和开票信息(盖公章)附件列表
    accountInformationAndBillingInformationAttachmentUploadSuccess(
      res,
      file,
      list
    ) {
      if (res.code == 10000000) {
        this.ruleForm.accountInformationAndBillingInformationAttachmentList.push(
          {
            attachmentItem: res.data.path,
          }
        );
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.accountInformationAndBillingInformationAttachmentList.push({
                url: res.data,
              });
              this.accountInformationAndBillingInformationAttachmentImgList =
                list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("资质证明照片上传失败");
      }
    },

    //删除一个营业执照正本(通过年审)附件列表
    handletriangleRemove(FileItem) {
      let index = this.triangleFileList.indexOf(FileItem);
      this.triangleFileList.splice(index, 1);
      this.ruleForm.businessLicenseAttachmentList.splice(index, 1);
      this.triangleFileImgList.splice(index, 1);
    },
    //删除一个资质证书(通过年审)附件列表
    handleCosmeticSanitationRemove(FileItem) {
      let index = this.cosmeticSanitationFileList.indexOf(FileItem);
      this.cosmeticSanitationFileList.splice(index, 1);
      this.ruleForm.qualificationAttachmentList.splice(index, 1);
      this.cosmeticSanitationFileImgList.splice(index, 1);
    },
    //安全生产许可证
    handlesafetyProductionLicenseAttachmentRemove(FileItem) {
      let index = this.safetyProductionLicenseAttachmentList.indexOf(FileItem);
      this.safetyProductionLicenseAttachmentList.splice(index, 1);
      this.ruleForm.safetyProductionLicenseAttachmentList.splice(index, 1);
      this.safetyProductionLicenseAttachmentImgList.splice(index, 1);
    },

    //劳务资质证书
    handlelaborQualificationAttachmentRemove(FileItem) {
      let index = this.laborQualificationAttachmentList.indexOf(FileItem);
      this.laborQualificationAttachmentList.splice(index, 1);
      this.ruleForm.laborQualificationAttachmentList.splice(index, 1);
      this.laborQualificationAttachmentImgList.splice(index, 1);
    },

    //法人身份证
    handlecorporateIdCardAttachmentRemove(FileItem) {
      let index = this.corporateIdCardAttachmentList.indexOf(FileItem);
      this.corporateIdCardAttachmentList.splice(index, 1);
      this.ruleForm.corporateIdCardAttachmentList.splice(index, 1);
      this.corporateIdCardAttachmentImgList.splice(index, 1);
    },

    //委托人身份证
    handleclientIdCardAttachmentRemove(FileItem) {
      let index = this.clientIdCardAttachmentList.indexOf(FileItem);
      this.clientIdCardAttachmentList.splice(index, 1);
      this.ruleForm.clientIdCardAttachmentList.splice(index, 1);
      this.clientIdCardAttachmentImgList.splice(index, 1);
    },

    //法人委托书
    handlecorporateProxyStatementAttachmentRemove(FileItem) {
      let index = this.corporateProxyStatementAttachmentList.indexOf(FileItem);
      this.corporateProxyStatementAttachmentList.splice(index, 1);
      this.ruleForm.corporateProxyStatementAttachmentList.splice(index, 1);
      this.corporateProxyStatementAttachmentImgList.splice(index, 1);
    },

    //账户信息和开票信息(盖公章)
    handleaccountInformationAndBillingInformationAttachmentRemove(FileItem) {
      let index =
        this.accountInformationAndBillingInformationAttachmentList.indexOf(
          FileItem
        );
      this.accountInformationAndBillingInformationAttachmentList.splice(
        index,
        1
      );
      this.ruleForm.accountInformationAndBillingInformationAttachmentList.splice(
        index,
        1
      );
      this.accountInformationAndBillingInformationAttachmentImgList.splice(
        index,
        1
      );
    },

    //其他资料1
    restsUploadSuccess1(res, file, list) {
      if (res.code == 10000000) {
        // this.ruleForm.idCardBackUrl = res.data.path;
        this.ruleForm.other1AttachmentList.push({
          attachmentItem: res.data.path,
        });
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.restsFileList1.push({ url: res.data });
              this.restsFileImgList1 = list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("其他材料照片上传失败");
      }
    },

    //其他资料2
    restsUploadSuccess2(res, file, list) {
      if (res.code == 10000000) {
        // this.ruleForm.idCardBackUrl = res.data.path;
        this.ruleForm.other2AttachmentList.push({
          attachmentItem: res.data.path,
        });
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.restsFileList2.push({ url: res.data });
              this.restsFileImgList2 = list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("其他材料照片上传失败");
      }
    },

    //其他资料3
    restsUploadSuccess3(res, file, list) {
      if (res.code == 10000000) {
        // this.ruleForm.idCardBackUrl = res.data.path;
        this.ruleForm.other3AttachmentList.push({
          attachmentItem: res.data.path,
        });
        let reqParam = {
          filePath: res.data.path,
        };
        getTempUrlService(reqParam).then(
          (res) => {
            if (res.code == 10000000) {
              //查看附件
              this.restsFileList3.push({ url: res.data });
              this.restsFileImgList3 = list;
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        );
      } else {
        // this.shopPicList.splice(this.shopPicList.length-1,1);
        this.$alert("其他材料照片上传失败");
      }
    },
    handleRestsRemove1(restsFileItem) {
      let index = this.restsFileList1.indexOf(restsFileItem);
      this.ruleForm.other1AttachmentList.splice(index, 1);
      this.restsFileList1.splice(index, 1);
      this.restsFileImgList1.splice(index, 1);
    },
    handleRestsRemove2(restsFileItem) {
      let index = this.restsFileList2.indexOf(restsFileItem);
      this.ruleForm.other2AttachmentList.splice(index, 1);
      this.restsFileList2.splice(index, 1);
      this.restsFileImgList2.splice(index, 1);
    },
    handleRestsRemove3(restsFileItem) {
      let index = this.restsFileList3.indexOf(restsFileItem);
      this.ruleForm.other3AttachmentList.splice(index, 1);
      this.restsFileList3.splice(index, 1);
      this.restsFileImgList3.splice(index, 1);
    },
    //预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 图片大小不能超过1M
    beforeUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (testmsg == "jpeg" || testmsg == "jpg" || testmsg == "png") {
        if (!isLt2M) {
          this.$alert("图片大小不能超过1M", {
            confirmButtonText: "确定",
          });
          return false;
        } else {
          return true;
        }
      } else {
        this.$alert("仅支持jpg、jpeg和png格式的图片", {
          confirmButtonText: "确定",
        });
        return false;
      }
    },

    // 图片大小不能超过5M
    beforeMaxUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (
        testmsg == "jpeg" ||
        testmsg == "jpg" ||
        testmsg == "png" ||
        testmsg == "JPEG" ||
        testmsg == "JPG" ||
        testmsg == "PNG"
      ) {
        if (!isLt2M) {
          this.$alert("图片大小不能超过5M", {
            confirmButtonText: "确定",
          });
          return false;
        } else {
          return true;
        }
      } else {
        this.$alert("仅支持jpg、jpeg和png格式的图片", {
          confirmButtonText: "确定",
        });
        return false;
      }
    },
    changeapproveTemplateType() {
      this.ruleForm.approveProcessCreateDtoList = [];
      this.selectTemplateItems=this.approveTemplate.find(item=>item.label===this.ruleForm.approveTemplateType)
      this.approveType=this.selectTemplateItems.label;
      this.ruleForm.approveTemplateName=this.selectTemplateItems.value;
      //  this.$refs.masterEvaluate.getDepartList(this.ruleForm.approveTemplateType);
    },

    dateFormat() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
    },
    //提交
    submitBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.approveProcessCreateDtoList) {
            this.$alert("未配置审批人员", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          if (this.ruleForm.approveProcessCreateDtoList.length > 0) {
            for (
              let i = 0;
              i < this.ruleForm.approveProcessCreateDtoList.length;
              i++
            ) {
              if (
                !this.ruleForm.approveProcessCreateDtoList[i].approveUserId ||
                this.ruleForm.approveProcessCreateDtoList[i].approveUserId == ""
              ) {
                this.$alert("未配置审批人员", "提示", {
                  confirmButtonText: "确定",
                });
                return;
              }
            }
          } else {
            this.$alert("未配置审批人员", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }

          if (this.editFlag) {
            //更新供应商
            this.ruleForm.id = this.supplierId;
            updateSupplierBInfo(this.ruleForm).then((res) => {
              if (res.code == 10000000) {
                //保存审批流
                this.saveApproveFun(this.supplierId);
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            this.ruleForm.approveStatus = 0;
            saveSupplierBInfo(this.ruleForm).then((res) => {
              if (res.code == 10000000) {
                //保存审批流
                this.saveApproveFun(res.data.id);
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //创建审批流函数
    saveApproveFun(id) {
      let param = { approveProcessDtoList: [] };
      param.approveProcessDtoList = this.ruleForm.approveProcessCreateDtoList;
      param.itemId = id;
      param.approveStatusEnum = "READY";
      param.approveClass = "SUPPLIER";
      let approveTemplateName =
        this.ruleForm.approveTemplateType === "1"
          ? "劳务"
          : this.ruleForm.approveTemplateType === "2"
          ? "机械"
          : "材料";
      param.itemName = `${sessionStorage.getItem("name")} 保存了关于企业信息 ${
        this.ruleForm.companyName
      } 的 ${approveTemplateName}审批流 申请`;

      saveSupplierApproveService(param).then((res) => {
        if (res.code == 10000000) {
          this.$refs.ruleForm.clearValidate();
          this.$refs["ruleForm"].clearValidate();
          if (!this.editFlag) {
            this.$message.success("保存成功");
            this.bus.$emit("tabClose", "addSupplierBSelfPage");
          } else {
            this.$message.success("更新成功");
            this.bus.$emit("tabClose", "editSupplierBSelfPage");
          }
          this.bus.$emit("navMenuChange", {
            routeId: "supplierBSelfMag",
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCheckChange(val) {
      //复选框选择改变事件
      if (val == 0) {
        //不置顶
        if (this.checkedone) {
          this.ruleForm.isTop = 0;
          this.checkedtwo = false;
          // this.TopSupplier(this.ruleForm.isTop);
          this.$forceUpdate();
        }
      } else {
        if (this.checkedtwo) {
          this.ruleForm.isTop = 1;
          this.checkedone = false;
          // this.TopSupplier(this.ruleForm.isTop);
          this.$forceUpdate();
        } else {
          this.ruleForm.isTop = 0;
        }
      }
    },
    //置顶供应商
    TopSupplier(val) {
      // let msg = "确认启用该供应商吗?";
      let param = {
        id: this.supplierId,
        isTop: val, //sessionStorage.getItem("userCode"),
      };
      // if (val == 0) {
      //   msg = "确认停用该供应商吗?";
      // }
      updateSupplierStatus(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.$alert("操作成功", "提示", {
              confirmButtonText: "确定",
            });
          } else if (res.code > 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },
    //取消按钮
    goBack() {
      let that = this;
      this.$refs.ruleForm.clearValidate();
      this.ruleForm.licenseAttachmentList = []; //营业执照
      this.ruleForm.idCardAttachmentList = []; //身份证正面
      this.ruleForm.qualificationAttachmentList = []; //资质证明
      this.ruleForm.recommendationAttachmentList = []; //合作单位推荐表
      this.ruleForm.otherAttachmentList = []; //其他材料

      if (this.editFlag) {
        this.bus.$emit("tabClose", "editSupplierBSelfPage");
        this.bus.$emit("navMenuChange", {
          routeId: "supplierBSelfMag",
        });
      } else {
        this.bus.$emit("tabClose", "addSupplierBSelfPage");
        this.bus.$emit("navMenuChange", {
          routeId: "supplierBSelfMag",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.enterpriseAndCommonality {
  background-color: white;
  // height: 100%;
}
/deep/.el-popover {
  padding: 24px;
}
/deep/.imgMaskDialog {
  .el-dialog__close {
    font-size: 30px;
    font-weight: 600;
  }
}
.AddSupplierA {
  width: 82%;
  .time-box {
    //  display: flex;
    // height: 180px;
    overflow-y: auto;
    flex: 1;

    .item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }

  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-right: 40px;
    width: 90%;
  }

  .right {
    height: 32px;
    line-height: 32px;
    width: 60px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 20px;
  }

  .add {
    background-color: #38b1c9;
    border-radius: 2px;
    color: #ecf5ff;
  }
}
@media only screen and(max-width:1680px) {
  .AddSupplierA {
    width: 90%;
  }
}
.AddSupplierA {
  background: rgba(255, 255, 255, 1);
  .el-form-item {
    width: 100%;
  }

  .el-checkbox {
    line-height: 40px;
  }

  .el-textarea {
    min-width: 0px !important;
  }
  .el-cascader {
    width: 100%;
  }

  .el-form-item__content {
    width: calc(100% - 110px);

    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
  }
  .bottomBtn {
    border-top: 1px solid #e6e6e6;
    width: 80%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    margin-bottom: 20px;
  }
  .AddSupplierATitle {
    height: 44px;
    padding-left: 24px;
    box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
    border-radius: 2px 2px 0px 0px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 44px;
    text-align: left;
  }
  .AddSupplierAContent {
    padding: 24px;
  }
  /deep/.daterangePicker {
    width: 255px;
    height: 32px;
    .el-input__icon {
      display: flex;
      align-items: center;
    }
    .el-range-separator {
      display: flex;
      align-items: center;
    }
  }

  .businessBox {
    display: flex;
    margin-bottom: 24px;
    .businessTitle {
      width: 195px;
      padding-right: 12px;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      flex-wrap: wrap;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606266;
        line-height: 22px;
      }
      .startTxt {
        color: #f56c6c;
        margin-right: 4px;
      }
      img {
        width: 14px;
        height: 14px;
        margin: 4px 2px 0 4px;
      }
    }
    .certificateTitle {
      width: 210px;
      padding-right: 12px;
      box-sizing: border-box;
      text-align: right;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606266;
        line-height: 22px;
      }
      img {
        width: 14px;
        height: 14px;
        margin: 4px 2px 0 4px;
      }
    }
    .secondUpload {
      margin-top: 0px;
    }
    /deep/.upload-demo {
      .el-upload-dragger {
        width: 380px;
        height: 194px;
        background: rgba(251, 251, 251, 1);
        border-radius: 2px;
        border: 1px dashed rgba(217, 217, 217, 1);
        .fileImgIcon {
          margin: 39px 0 21px 0;
        }
        .dragTxt {
          width: 242px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 20px;
          margin: 0 auto;
        }
        .imgSizeTxt {
          width: 242px;
          height: 34px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 17px;
          margin: 2px auto 0;
        }
      }
      .uploadImgBox {
        width: 100%;
        height: 194px;
        position: relative;
        img {
          width: 100%;
        }
        .coloseAndPreviewBtnList {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          position: absolute;
          top: 157px;
          div {
            width: 56px;
            height: 26px;
            background: rgba(0, 0, 0, 1);
            border-radius: 13px;
            opacity: 0.8;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            line-height: 26px;
          }
          .closeBtn {
            margin-right: 8px;
          }
          .PreviewBtn {
            margin-right: 10px;
          }
        }
      }
    }
    /deep/.selectBox {
      .selectItem {
        width: 121px;
        height: 32px;
        margin-right: 8px;
        .el-input__inner {
          width: 121px;
          height: 32px;
        }
        .el-input__icon {
          line-height: 32px;
        }
      }
      .selectItem:nth-child(3n) {
        margin-right: 0px;
      }
      .textareaTxt {
        width: 380px;
        margin-top: 10px;
        textarea {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
    }
  }
  .addImgUploadBox {
    .addImgUpload {
      .addImgBox {
        width: 50px;
        height: 50px;
        border-radius: 2px;
        border: 1px dashed rgba(223, 223, 228, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        .addImgIcon {
          width: 18px;
          height: 18px;
          img {
            width: 18px;
            height: 18px;
          }
        }
      }
      .imgIconTxt {
        margin-top: 7px;
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 14px;
      }
    }
    .UploadImgList {
      margin-top: 16px;
      .UploadImgItem {
        width: 380px;
        height: 66px;
        background: rgba(251, 251, 251, 1);
        border-radius: 4px;
        border: 1px dashed rgba(217, 217, 217, 1);
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        .UploadImgLeft {
          height: 66px;
          display: flex;
          align-items: center;
          .UploadItemImg {
            width: 54px;
            height: 54px;
            padding-left: 8px;
            overflow: hidden;
            img {
              width: 54px;
            }
          }
          .UploadItemInfo {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            margin-left: 13px;
            .UploadItemName {
              width: 200px;
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 20px;
              text-align: left;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .UploadItemSize {
              height: 17px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 17px;
              text-align: left;
              margin-top: 6px;
            }
          }
        }
        .UploadImgBtnList {
          display: flex;
          align-items: flex-end;
          div {
            width: 28px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 20px;
            margin-bottom: 11px;
            cursor: pointer;
          }
          .previewBtn {
            margin-left: 12px;
            margin-right: 13px;
          }
        }
      }
      .UploadImgItem:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
